import { render } from "./CourseCreateSubpage.vue?vue&type=template&id=dddc80a8&scoped=true"
import script from "./CourseCreateSubpage.vue?vue&type=script&lang=js"
export * from "./CourseCreateSubpage.vue?vue&type=script&lang=js"

import "./CourseCreateSubpage.vue?vue&type=style&index=0&id=dddc80a8&lang=css"
import "./CourseCreateSubpage.vue?vue&type=style&index=1&id=dddc80a8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dddc80a8"]])

export default __exports__